(function() { window.GUID_7d3e6e23_f2ea_4f07_b7fb_d9f1a6024530 = { getGuid: function() { return "7d3e6e23-f2ea-4f07-b7fb-d9f1a6024530"; } }; })();
var CompuSport;
(function (CompuSport) {
    let currentToolTip;
    function ShowToolTip($target, content = null) {
        if (content != null && content.trim() != "") {
            currentToolTip.ShowToolTip($target, content);
        }
        else {
            currentToolTip.ClearToolTip();
        }
    }
    CompuSport.ShowToolTip = ShowToolTip;
    class Tooltip {
        constructor() {
            this.tooltipTimer = null;
            this.lastToolTip = null;
            let me = this;
            CompuSport.DOM.doc.off('mouseover.cstooltip focusin.cstooltip');
            CompuSport.DOM.doc.on('mouseover.cstooltip focusin.cstooltip', '[data-tooltip]', function (e) {
                var $target = $(e.target).closest('[data-tooltip]');
                me.ShowToolTip($target);
            }).on('mouseleave.cstooltip blur.cstooltip focusout.cstooltip mousewheel.cstooltip', '[data-tooltip]', function (e) {
                me.ClearToolTip();
            }).on('mouseup.cstooltip autocomplete.shown', function () {
                me.ClearToolTip();
            });
        }
        ShowToolTip($target, content = null) {
            let me = this;
            if ($target.is("[title]")) {
                $target
                    .data("keepedTitle", $target.attr("title"))
                    .removeAttr("title");
            }
            me.tooltipTimer = CompuSport.Lag(250, function () {
                if (me.lastToolTip != null) {
                    me.lastToolTip.remove();
                }
                var $tooltip = $('<div id="CSToolTip" class="Content"></div>');
                me.lastToolTip = $tooltip;
                var tooltipVal = $target.attr('data-tooltip');
                if (content != null && content != "") {
                    tooltipVal = content;
                }
                if (tooltipVal == null || tooltipVal == "") {
                    tooltipVal = $target.data('keepedTitle');
                }
                if ($target[0].tagName == "IMG" && $target.data('forcetooltip') == null) {
                    if (tooltipVal != null && tooltipVal != "") {
                        $tooltip[0].innerHTML = "<img class='tooltipOfImg' src=" + tooltipVal + " />";
                    }
                    else {
                        $tooltip[0].innerHTML = "<img class='tooltipOfImg' src=" + $target[0].src + " />";
                    }
                }
                else if (tooltipVal != null && tooltipVal != "") {
                    $tooltip[0].innerHTML = decodeURIComponent(tooltipVal);
                    if ($target.hasClass("IsDisabled")) {
                        $('.HowToEnable', $tooltip).addClass("IsEnabled");
                    }
                }
                else {
                    $tooltip[0].innerHTML = $target[0].title;
                }
                if ($tooltip[0].innerHTML == "") {
                    return;
                }
                $tooltip[0].innerHTML += "<div id='ToolTipArrow'></div>";
                var classToAdd = CompuSport.Layout.PositionTargetRefToSourceAndWindows($target, $tooltip);
                $tooltip.addClass(classToAdd);
                $tooltip.target = $target;
                $target.addClass('Tooltiped');
                $tooltip.appendTo(CompuSport.DOM.body);
                if ($tooltip.hasClass('LayoutHelperLeft')) {
                    $tooltip.css({ 'margin-left': ($target.width() - 40) + 'px' });
                }
                else {
                    $tooltip.css({ 'margin-right': ($target.width() - 40) + 'px' });
                }
            });
        }
        ClearToolTip() {
            let me = this;
            if (me.lastToolTip != null) {
                var $target = me.lastToolTip.target;
                if ($target != null) {
                    $target.removeClass('Tooltiped');
                }
                me.lastToolTip.remove();
            }
            clearTimeout(me.tooltipTimer);
        }
    }
    CompuSport.Tooltip = Tooltip;
    currentToolTip = new Tooltip();
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Tooltip.desktop.js.map
